import { SpareInOutService } from "../service/spare-in-out.service";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { SpareInOut } from "../models/spareinout";
import { SparepartService } from "../services/sparepart.service";
import _ from "lodash";
import { AuthService } from "../services/auth.service";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";
import { MatDialog } from "@angular/material";
import { Message } from "../common/message";
import { MessageService } from "../services/message.service";
import { SpinnerService } from "./../services/spinner.service";
import { ConfirmBigSearchDialogComponent } from "../dialog/confirm-big-search-dialog/confirm-big-search-dialog.component";
import { StockService } from "../services/stock.service";
import { PowertrainService } from "../services/powertrain.service";

let ELEMENT_DATA = [];

@Component({
  selector: "app-item-report-inventory",
  templateUrl: "./item-report-inventory.component.html",
  styleUrls: ["./item-report-inventory.component.scss"],
})
export class ItemReportInventoryComponent implements OnInit {
  ELEMENT_DATA: any[];
  data: any[];
  items: any[];
  stores: any[];
  powerTrains: any;
  searchedEngines: any;
  displayedColumns: string[] = [
    "SN",
    "from",
    "to",
    "item",
    "qty",
    "type",
    "engine",
    "powertrain",
    "reason",
    "created",
    "action",
  ];
  dataSource = new MatTableDataSource();
  resource: SpareInOut = new SpareInOut();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() showItemDetails: boolean = false;
  @Input() showDeleteAction: boolean = false;

  mainId: string = "5d5dc40206521f510ca6de43";
  spainId: string = "5d5dc41b06521f510ca6de45";
  frenchId: string = "5d5dc40e06521f510ca6de44";
  sleepId: string = "5d9e6422f6509d001799d4e1";
  aboGhates: string = "621f26a32ca9250018375095";
  mhatetMisr: string = "63eca16f52e4d000161ff624";
  bashteel:string = "673991b2c6cac20015cd473d";

  searchObject: any = {
    dateFrom: null,
    dateTo: null,
    engine: null,
    powerCoach: null,
  };

  printedItem: string = "";
  selectedItem: any = null;
  storeFrom: any = null;
  storeTo: any = null;
  powerCoach: any = null;
  engine: any = null;

  inventoryObject: any = {
    Main: "",
    Spain: "",
    French: "",
    Sleep: "",
    AboGhates: "",
    MhatetMisr: "",
    Bashteel:"",
    Total: "",
  };
  constructor(
    private service: SpareInOutService,
    private spService: SparepartService,
    private stService: StockService,
    private authService: AuthService,
    private dialog: MatDialog,
    private msg: MessageService,
    private ptService: PowertrainService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    //this.getResources();
    this.getItems();
    this.getStores();
    this.getPowertrains();
  }

  searchByPowerCoach(powerCoach) {
    //this.searchedList = [];
    if (powerCoach && powerCoach != "null") {
      for (let obj of this.powerTrains) {
        if (obj.id == powerCoach) {
          this.powerCoach = obj;
          if (obj && obj.motors && obj.motors.length) {
            this.searchedEngines = obj.motors;
            this.searchObject.engine = null;
            return;
          } else {
            this.searchedEngines = [];
            this.searchObject.engine = null;
            return;
          }
        }
      }
    } else {
      this.powerCoach = null;
      this.engine = null;
      this.searchObject.engine = null;
      this.searchObject.powerCoach = null;
      this.searchedEngines = [];
    }
  }

  onEngineSelect(engine) {
    this.searchObject.engine = engine != "null" ? engine : null;
    this.engine =
      this.searchedEngines.filter((obj: any) => obj.id === engine)[0] || null;
  }

  getPowertrains() {
    this.powerTrains = [];
    this.searchedEngines = [];
    this.ptService.getAll().subscribe((result) => {
      this.powerTrains = this.powerTrains.concat(result);
    });
  }

  getIndex(element: any) {
    const i = _.findIndex(ELEMENT_DATA, element);
    return i + 1;
  }

  searchByItem() {
    if (
      !this.resource.item &&
      !this.searchObject.powerCoach &&
      !this.searchObject.engine &&
      !this.searchObject.dateFrom &&
      !this.searchObject.dateTo
    ) {
      this.dialog
        .open(ConfirmBigSearchDialogComponent)
        .afterClosed()
        .subscribe((result) => {
          if (result == "true") {
            this.getResources();
          } else {
            return;
          }
        });
    } else {
      this.getResources();
    }
  }

  clearDates() {
    this.searchObject.dateFrom = null;
    this.searchObject.dateTo = null;
  }

  onItemSelect(item: string) {
    this.resource.item = item != "null" ? item : null;
    this.selectedItem =
      this.items.filter((obj: any) => obj.id === item)[0] || null;
    this.printedItem = "";
  }

  onStoreFromSelect(storeFrom: string) {
    this.resource.from = storeFrom != "null" ? storeFrom : null;
    this.storeFrom =
      this.stores.filter((obj: any) => obj.id === storeFrom)[0] || null;
  }

  onStoreToSelect(storeTo: string) {
    this.resource.to = storeTo != "null" ? storeTo : null;
    this.storeTo =
      this.stores.filter((obj: any) => obj.id === storeTo)[0] || null;
  }

  getTotals() {
    if (!this.data || !this.data.length) return;

    const arr = this.data;

    this.inventoryObject = {
      Main: this.getMainQty(arr),
      Spain: this.getSpainQty(arr),
      French: this.getFrenchQty(arr),
      Sleep: this.getSleepQty(arr),
      AboGhates: this.getAboGhatesQty(arr),
      MhatetMisr: this.getMhatetMisrQty(arr),
      Bashteel:this.getBashteelQty(arr),
      Total: this.getTotal(arr),
    };
  }

  getMainQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.mainId) {
        qty += i.qty;
      }
      if (i.from == this.mainId) {
        qty -= i.qty;
      }
    }

    return qty;
  }

  getSpainQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.spainId) {
        qty += i.qty;
      }
      if (i.from == this.spainId) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getFrenchQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.frenchId) {
        qty += i.qty;
      }
      if (i.from == this.frenchId) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getSleepQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.sleepId) {
        qty += i.qty;
      }
      if (i.from == this.sleepId) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getAboGhatesQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.aboGhates) {
        qty += i.qty;
      }
      if (i.from == this.aboGhates) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getMhatetMisrQty(list: any) {
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.mhatetMisr) {
        qty += i.qty;
      }
      if (i.from == this.mhatetMisr) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getBashteelQty(list: any){
    let qty = 0;
    for (let i of list) {
      if (i.to && i.to == this.bashteel) {
        qty += i.qty;
      }
      if (i.from == this.bashteel) {
        qty -= i.qty;
      }
    }
    return qty;
  }

  getTotal(list: any) {
    return (
      this.getMainQty(list) +
      this.getSpainQty(list) +
      this.getFrenchQty(list) +
      this.getSleepQty(list) +
      this.getAboGhatesQty(list) +
      this.getMhatetMisrQty(list) + 
      this.getBashteelQty(list)
    );
  }

  getItems() {
    this.items = [];
    this.spService.getAll().subscribe((result) => {
      this.items = this.items.concat(result);
    });
  }

  getStores() {
    this.stores = [];
    this.stService.getAll().subscribe((result) => {
      this.stores = this.stores.concat(result);
    });
  }

  getResources() {
    this.searchObject.dateFrom
      ? this.searchObject.dateFrom
      : new Date("1/1/2018"),
      this.searchObject.dateTo
        ? new Date(
            `${this.searchObject.dateTo.toLocaleDateString("en-US")} 23:59:59`
          )
        : new Date();
    this.data = [];
    ELEMENT_DATA = [];
    this.service
      .getAllResources(this.resource, this.searchObject)
      .subscribe((result: any) => {
        if (result && result.length) {
          this.spinnerService.show();
          this.data = this.data.concat(result);
          ELEMENT_DATA = ELEMENT_DATA.concat(result);
          this.updateDataSource(ELEMENT_DATA);
          //get the quantities
          //this.onItemSelect(itemId);
          if (this.selectedItem) this.getTotals();
          this.spinnerService.hide();
        } else {
          this.data = [];
          ELEMENT_DATA = [];
          this.updateDataSource(ELEMENT_DATA);
          this.inventoryObject = {
            Main: "",
            Spain: "",
            French: "",
            Sleep: "",
            AboGhates: "",
            MhatetMisr: "",
            Bashteel:"",
            Total: "",
          };
        }
      });
  }

  updateDataSource(arr: any) {
    this.dataSource = new MatTableDataSource<any>(arr);
    this.dataSource.paginator = this.paginator;
  }

  delete(ele) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result == "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            // let index = ELEMENT_DATA.indexOf(ele);
            // ELEMENT_DATA.splice(index, 1);
            // this.updateDataSource();
            this.searchByItem();
          });
        } else {
          return;
        }
      });
  }
}
